// extracted by mini-css-extract-plugin
module.exports = {"creatingCase":"CreatingCase_creatingCase___INxG","input":"CreatingCase_input__3VJ17","button":"CreatingCase_button__ENCxg"};